"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMH = function FlagMH(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-189.82,145,216.6-23.13V-72.57L-193,139.3a6.94,6.94,0,0,0,3.18,5.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M213.93-120.34-193,132.23v7.07L216.6-72.57v-42.37a7,7,0,0,0-2.67-5.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff9b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.28-24.49l45.71-5.7L-76.28-35.9l23.17-14.21-28.82,7L-64.4-67-88.32-49.45l7-28.82-14.2,23.16-5.71-45.7-5.71,45.7-14.21-23.16,7,28.82L-138-67l17.54,23.93-28.82-7,23.16,14.21-45.7,5.71,45.7,5.7-23.16,14.21,28.82-7L-138,6.6l23.93-17.53-7,28.82L-106.9-5.28l5.71,45.71,5.71-45.71,14.2,23.17-7-28.82L-64.4,6.6-81.93-17.32l28.82,7Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMH;
exports["default"] = _default;